module.exports = ":host > ul {\n  margin-right: 25px; }\n  :host > ul > li {\n    display: inline; }\n  :host > ul > li:not(:last-child) {\n      margin-right: 5px; }\n  :host > ul > li i {\n      color: inherit; }\n  :host > ul > li .dropdown {\n      display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/layouts/toolbar/components/toolbar/toolbar.component.scss
// module id = ./libs/chassis-core/src/app/layouts/toolbar/components/toolbar/toolbar.component.scss
// module chunks = main